export const SET_PAGINATION = 'pagination/SET_PAGINATION'
